// Runtime mirrors of the API's Prisma/GraphQL enums. Never import
// @prisma/client on the web side — it breaks the browser bundle.

export enum MigrationProvider {
  DRIVER_REACH = 'DRIVER_REACH',
  TENSTREET = 'TENSTREET',
  COMPANY = 'COMPANY',
  CSV = 'CSV',
  OTHER = 'OTHER',
}

/**
 * -ING phases: a machine is actively running and the row advances on its own.
 * Past-participle/READY_ phases: parked, waiting on a defined trigger
 * (system signal or ADMIN/OPS action).
 */
export enum DataMigrationPhase {
  INITIATED = 'INITIATED',
  DOWNLOADING = 'DOWNLOADING',
  EXTRACTING = 'EXTRACTING',
  UPLOADING = 'UPLOADING',
  UPLOADED = 'UPLOADED',
  TRANSFORMING = 'TRANSFORMING',
  READY_FOR_REVIEW = 'READY_FOR_REVIEW',
  STAGING_APPLICANTS = 'STAGING_APPLICANTS',
  READY_TO_MIGRATE = 'READY_TO_MIGRATE',
  MIGRATING = 'MIGRATING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}
